module.exports = __webpack_public_path__ + "img/munic-exaltacion-de-la-cruz.70e3e786.png";